
    <template>
      <section class="content element-doc">
        <h2>Select 下拉框</h2>
<p>当选项过多时，使用下拉菜单展示并选择内容。</p>
<h3>基本用法</h3>
<p>适用广泛的基础单选</p>
<demo-block>
        <div><p><code>v-model</code>的值为当前被选中的下拉值。</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-select v-model=&quot;selectValue&quot; :options=&quot;options&quot; @change=&quot;onChange&quot; /&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        selectValue: '',
        options: [
          { label: '标题1', value: 1 },
          { label: '标题2', value: 2 },
          { label: '标题3', value: 3 },
          { label: '标题4', value: 4 },
          { label: '标题5', value: 5 }
        ]
      };
    },
    methods: {
      onChange(val) {
        console.log(val)
      }
    }
  };
&lt;/script&gt;
</code></pre></template></demo-block><h3>指定 options 的 label 和 value</h3>
<p>接口返回的数组指定字段名</p>
<demo-block>
        <div><p>设置<code>props</code>的<code>label</code>和<code>value</code>属性值指定字段名，当开启<code>localFilter</code>时，<code>key</code>默认绑定的是<code>value</code>。</p>
</div>
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-select v-model=&quot;selectValue&quot; :options=&quot;options&quot; :props=&quot;{ label: 'name', value: 'code', key: 'code' }&quot; /&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        selectValue: '',
        options: [
          { name: '标题1', code: 1 },
          { name: '标题2', code: 2 },
          { name: '标题3', code: 3 },
          { name: '标题4', code: 4 },
          { name: '标题5', code: 5 }
        ]
      };
    }
  };
&lt;/script&gt;
</code></pre></template></demo-block><h3>本地过滤大数据下拉框</h3>
<p>当有几千条下拉数据时会造成页面卡顿，可以使用该方法</p>
<demo-block>
        <div><p>设置<code>remote</code>和<code>localFilter</code>来开启该功能，可以设置<code>localFilter.max</code>为一个<code>number</code>类型的值来自定义显示多少条，默认展示20条。</p>
</div>
        <template slot="source"><element-demo2 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-select v-model=&quot;selectValue&quot; :options=&quot;options&quot; remote :local-filter=&quot;{ max: 10 }&quot; /&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        selectValue: '',
        options: [
          { label: '标题1', value: 1 },
          { label: '标题2', value: 2 },
          { label: '标题3', value: 3 },
          { label: '标题4', value: 4 },
          { label: '标题5', value: 5 },
          { label: '标题6', value: 6 },
          { label: '标题7', value: 7 },
          { label: '标题8', value: 8 },
          { label: '标题9', value: 9 },
          { label: '标题10', value: 10 },
          { label: '标题11', value: 11 },
          { label: '标题12', value: 12 },
          { label: '标题13', value: 13 },
          { label: '标题14', value: 14 },
          { label: '标题15', value: 15 },
          { label: '标题16', value: 16 },
          { label: '标题17', value: 17 },
          { label: '标题18', value: 18 },
          { label: '标题19', value: 19 },
          { label: '标题20', value: 20 },
          { label: '标题21', value: 21 },
          { label: '标题22', value: 22 },
          { label: '标题23', value: 23 },
          { label: '标题24', value: 24 },
          { label: '标题25', value: 25 },
        ]
      };
    }
  };
&lt;/script&gt;
</code></pre></template></demo-block><h3>Select Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>v-model</td>
<td>绑定值</td>
<td>boolean / string / number</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>options</td>
<td>下拉框的数组</td>
<td>array</td>
<td>—</td>
<td>[]</td>
</tr>
<tr>
<td>props</td>
<td>options 的 label 和 value</td>
<td>object</td>
<td>—</td>
<td>{ label: 'label', value: 'value', key: index }</td>
</tr>
<tr>
<td>localFilter</td>
<td>本地过滤大数据下拉框</td>
<td>boolean/object</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>remoteCinfig</td>
<td>远程搜索配置项</td>
<td>object</td>
<td>—</td>
<td>{ api, field, params }</td>
</tr>
<tr>
<td>multiple</td>
<td>是否多选</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>disabled</td>
<td>是否禁用</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>value-key</td>
<td>作为 value 唯一标识的键名，绑定值为对象类型时必填</td>
<td>string</td>
<td>—</td>
<td>value</td>
</tr>
<tr>
<td>size</td>
<td>输入框尺寸</td>
<td>string</td>
<td>medium/small/mini</td>
<td>—</td>
</tr>
<tr>
<td>clearable</td>
<td>是否可以清空选项</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>collapse-tags</td>
<td>多选时是否将选中值按文字的形式展示</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>multiple-limit</td>
<td>多选时用户最多可以选择的项目数，为 0 则不限制</td>
<td>number</td>
<td>—</td>
<td>0</td>
</tr>
<tr>
<td>name</td>
<td>select input 的 name 属性</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>autocomplete</td>
<td>select input 的 autocomplete 属性</td>
<td>string</td>
<td>—</td>
<td>off</td>
</tr>
<tr>
<td>auto-complete</td>
<td>下个主版本弃用</td>
<td>string</td>
<td>—</td>
<td>off</td>
</tr>
<tr>
<td>placeholder</td>
<td>占位符</td>
<td>string</td>
<td>—</td>
<td>请选择</td>
</tr>
<tr>
<td>filterable</td>
<td>是否可搜索</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>allow-create</td>
<td>是否允许用户创建新条目，需配合 <code>filterable</code> 使用</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>filter-method</td>
<td>自定义搜索方法</td>
<td>function</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>remote</td>
<td>是否为远程搜索</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>remote-method</td>
<td>远程搜索方法</td>
<td>function</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>loading</td>
<td>是否正在从远程获取数据</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>loading-text</td>
<td>远程加载时显示的文字</td>
<td>string</td>
<td>—</td>
<td>加载中</td>
</tr>
<tr>
<td>no-match-text</td>
<td>搜索条件无匹配时显示的文字，也可以使用<code>slot=&quot;empty&quot;</code>设置</td>
<td>string</td>
<td>—</td>
<td>无匹配数据</td>
</tr>
<tr>
<td>no-data-text</td>
<td>选项为空时显示的文字，也可以使用<code>slot=&quot;empty&quot;</code>设置</td>
<td>string</td>
<td>—</td>
<td>无数据</td>
</tr>
<tr>
<td>popper-class</td>
<td>Select 下拉框的类名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>reserve-keyword</td>
<td>多选且可搜索时，是否在选中一个选项后保留当前的搜索关键词</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>default-first-option</td>
<td>在输入框按下回车，选择第一个匹配项。需配合 <code>filterable</code> 或 <code>remote</code> 使用</td>
<td>boolean</td>
<td>-</td>
<td>false</td>
</tr>
<tr>
<td>popper-append-to-body</td>
<td>是否将弹出框插入至 body 元素。在弹出框的定位出现问题时，可将该属性设置为 false</td>
<td>boolean</td>
<td>-</td>
<td>true</td>
</tr>
<tr>
<td>automatic-dropdown</td>
<td>对于不可搜索的 Select，是否在输入框获得焦点后自动弹出选项菜单</td>
<td>boolean</td>
<td>-</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3>Select Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>选中值发生变化时触发</td>
<td>目前的选中值</td>
</tr>
<tr>
<td>visible-change</td>
<td>下拉框出现/隐藏时触发</td>
<td>出现则为 true，隐藏则为 false</td>
</tr>
<tr>
<td>remove-tag</td>
<td>多选模式下移除tag时触发</td>
<td>移除的tag值</td>
</tr>
<tr>
<td>clear</td>
<td>可清空的单选模式下用户点击清空按钮时触发</td>
<td>—</td>
</tr>
<tr>
<td>blur</td>
<td>当 input 失去焦点时触发</td>
<td>(event: Event)</td>
</tr>
<tr>
<td>focus</td>
<td>当 input 获得焦点时触发</td>
<td>(event: Event)</td>
</tr>
</tbody>
</table>
<h3>Option Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td>选项的值</td>
<td>string/number/object</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>label</td>
<td>选项的标签，若不设置则默认与 <code>value</code> 相同</td>
<td>string/number</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>disabled</td>
<td>是否禁用该选项</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3>Methods</h3>
<table>
<thead>
<tr>
<th>方法名</th>
<th>说明</th>
<th>参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>focus</td>
<td>使 input 获取焦点</td>
<td>-</td>
</tr>
<tr>
<td>blur</td>
<td>使 input 失去焦点，并隐藏下拉框</td>
<td>-</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-select',{attrs:{"options":_vm.options},on:{"change":_vm.onChange},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        selectValue: '',
        options: [
          { label: '标题1', value: 1 },
          { label: '标题2', value: 2 },
          { label: '标题3', value: 3 },
          { label: '标题4', value: 4 },
          { label: '标题5', value: 5 }
        ]
      };
    },
    methods: {
      onChange(val) {
        console.log(val)
      }
    }
  };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-select',{attrs:{"options":_vm.options,"props":{ label: 'name', value: 'code', key: 'code' }},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        selectValue: '',
        options: [
          { name: '标题1', code: 1 },
          { name: '标题2', code: 2 },
          { name: '标题3', code: 3 },
          { name: '标题4', code: 4 },
          { name: '标题5', code: 5 }
        ]
      };
    }
  };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-select',{attrs:{"options":_vm.options,"remote":"","local-filter":{ max: 10 }},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        selectValue: '',
        options: [
          { label: '标题1', value: 1 },
          { label: '标题2', value: 2 },
          { label: '标题3', value: 3 },
          { label: '标题4', value: 4 },
          { label: '标题5', value: 5 },
          { label: '标题6', value: 6 },
          { label: '标题7', value: 7 },
          { label: '标题8', value: 8 },
          { label: '标题9', value: 9 },
          { label: '标题10', value: 10 },
          { label: '标题11', value: 11 },
          { label: '标题12', value: 12 },
          { label: '标题13', value: 13 },
          { label: '标题14', value: 14 },
          { label: '标题15', value: 15 },
          { label: '标题16', value: 16 },
          { label: '标题17', value: 17 },
          { label: '标题18', value: 18 },
          { label: '标题19', value: 19 },
          { label: '标题20', value: 20 },
          { label: '标题21', value: 21 },
          { label: '标题22', value: 22 },
          { label: '标题23', value: 23 },
          { label: '标题24', value: 24 },
          { label: '标题25', value: 25 },
        ]
      };
    }
  };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  